__turbopack_context__.v({
  "fade-in": "RichTextWordJalousie-module-scss-module__4K57Na__fade-in",
  "paragraph": "RichTextWordJalousie-module-scss-module__4K57Na__paragraph",
  "reveal": "RichTextWordJalousie-module-scss-module__4K57Na__reveal",
  "underline": "RichTextWordJalousie-module-scss-module__4K57Na__underline",
  "word": "RichTextWordJalousie-module-scss-module__4K57Na__word",
  "wordInner": "RichTextWordJalousie-module-scss-module__4K57Na__wordInner",
});
